/* eslint-disable no-param-reassign */
import { useState } from 'react';
import PasswordWithErrorsInput from '../../inputs/password-with-errors-input/password-with-errors-input';

const PasswordWithConfirm = ({
  lengthPasswordError,
  matchPasswordError,
  inputId,
  confirmInputId,
  inputName,
  confirmInputName,
  label,
  confirmLabel,
  passwordException,
  confirmPasswordException,
}) => {
  const [pwMatch, setPwMatch] = useState(null);

  const checkPwMatch = () => {
    const newPwValue = document.getElementById(inputId).value;
    const confirmPwValue = document.getElementById(confirmInputId).value;
    document.getElementById(`${inputName}Error`).classList.add('d-none');
    if (confirmPwValue) {
      setPwMatch(newPwValue === confirmPwValue);
      document.getElementById(`${confirmInputName}Error`).classList.add('d-none');
    }
  };

  return (
    <>
      <div className="form-input m-b-16">
        <PasswordWithErrorsInput
          inputId={inputId}
          inputName={inputName}
          label={label}
          checkPwMatch={checkPwMatch}
          lengthError={lengthPasswordError}
          matchError={matchPasswordError}
          errorsToShow={['length']}
        />
        <div className={`warn error ${passwordException}`} id={`${inputName}Error`}>
          <CheckSvg color="gray" />
          <span id="hasLength" data-testid="newPasswordHasLength" className="m-l-8 c-light-midnight ff-graphik fs-p4">10 characters minimum</span>
        </div>
      </div>
      <div className="form-input">
        <PasswordWithErrorsInput
          inputId={confirmInputId}
          inputName={confirmInputName}
          label={confirmLabel}
          pwMatch={pwMatch}
          checkPwMatch={checkPwMatch}
          lengthError={lengthPasswordError}
          matchError={matchPasswordError}
          errorsToShow={['pwMatch']}
        />
        <div className={`warn error ${confirmPasswordException}`} id={`${confirmInputName}Error`}>
          <CheckSvg color="gray" />
          <span id="hasLength" data-testid="confirmPasswordHasLength" className="m-l-8 c-light-midnight ff-graphik fs-p4">Passwords must match</span>
        </div>
      </div>
    </>
  );
};
const CheckSvg = ({ id, name, color }) => {
  if (color === 'green') {
    color = '#008746';
  } else if (color === 'grey') {
    color = '#473F61';
  }
  return (
    <svg id={id} name={name} width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 3.45L3.45 5.55L7.65 1" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
export default PasswordWithConfirm;
